import { useState, useEffect } from "react";
import { api } from "../api";

const RUOLI = ["admin","dirigente","responsabile","venditore","readonly"];
const RUOLO_COLOR = {
  admin:         { bg: "#fef2f2", color: "#dc2626" },
  dirigente:     { bg: "#f5f3ff", color: "#7c3aed" },
  responsabile:  { bg: "#eff6ff", color: "#1d4ed8" },
  venditore:     { bg: "#f0fdf4", color: "#15803d" },
  readonly:      { bg: "#f8fafc", color: "#64748b" },
};

function RuoloBadge({ ruolo }) {
  const c = RUOLO_COLOR[ruolo] || { bg: "#f1f5f9", color: "#64748b" };
  return <span className="stato-badge" style={{ background: c.bg, color: c.color }}>{ruolo}</span>;
}

const VUOTO = { nome: "", email: "", password: "", ruolo: "venditore", responsabile_id: "", attivo: true };

export default function GestioneUtenti() {
  const [utenti, setUtenti]     = useState([]);
  const [loading, setLoading]   = useState(true);
  const [form, setForm]         = useState(null);   // null = lista, oggetto = modale
  const [isNuovo, setIsNuovo]   = useState(false);
  const [errore, setErrore]     = useState(null);
  const [saving, setSaving]     = useState(false);

  const carica = async () => {
    setLoading(true);
    try { setUtenti(await api.utenti()); }
    catch (e) { setErrore(e.message); }
    setLoading(false);
  };

  useEffect(() => { carica(); }, []);

  const apriNuovo = () => { setForm({ ...VUOTO }); setIsNuovo(true); setErrore(null); };
  const apriModifica = (u) => {
    setForm({ nome: u.nome, email: u.email, password: "", ruolo: u.ruolo,
              responsabile_id: u.responsabile_id || "", attivo: !!u.attivo, id: u.id });
    setIsNuovo(false); setErrore(null);
  };

  const salva = async () => {
    setSaving(true); setErrore(null);
    try {
      const payload = { ...form };
      if (!payload.password) delete payload.password;
      if (!payload.responsabile_id) payload.responsabile_id = null;

      if (isNuovo) await api.creaUtente(payload);
      else await api.modificaUtente(form.id, payload);

      setForm(null); carica();
    } catch (e) { setErrore(e.message); }
    setSaving(false);
  };

  const elimina = async (id) => {
    if (!window.confirm("Eliminare questo utente?")) return;
    try { await api.eliminaUtente(id); carica(); }
    catch (e) { alert(e.message); }
  };

  const responsabili = utenti.filter(u => u.ruolo === "responsabile");

  return (
    <div className="page">
      <div className="page-header">
        <h1>Gestione utenti</h1>
        <button className="btn btn-primary" onClick={apriNuovo}>+ Nuovo utente</button>
      </div>

      {loading && <div className="loading">Caricamento...</div>}
      {errore && !form && <div className="errore-box">⚠️ {errore}</div>}

      {/* Lista utenti */}
      {!loading && (
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#0f2850", color: "white" }}>
                <th style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Nome</th>
                <th style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Email</th>
                <th style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Ruolo</th>
                <th style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Responsabile</th>
                <th style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Stato</th>
                <th style={{ padding: "10px 16px" }}></th>
              </tr>
            </thead>
            <tbody>
              {utenti.map((u, i) => (
                <tr key={u.id} style={{ background: i % 2 === 0 ? "white" : "#f9fafb", borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "10px 16px", fontWeight: 600 }}>{u.nome}</td>
                  <td style={{ padding: "10px 16px", fontSize: 13, color: "#64748b" }}>{u.email}</td>
                  <td style={{ padding: "10px 16px" }}><RuoloBadge ruolo={u.ruolo} /></td>
                  <td style={{ padding: "10px 16px", fontSize: 12, color: "#64748b" }}>{u.responsabile_nome || "—"}</td>
                  <td style={{ padding: "10px 16px" }}>
                    <span className="stato-badge" style={{ background: u.attivo ? "#f0fdf4" : "#fef2f2", color: u.attivo ? "#15803d" : "#dc2626" }}>
                      {u.attivo ? "attivo" : "disabilitato"}
                    </span>
                  </td>
                  <td style={{ padding: "10px 16px", textAlign: "right" }}>
                    <button className="btn-icon" onClick={() => apriModifica(u)} title="Modifica">✏️</button>
                    <button className="btn-icon" onClick={() => elimina(u.id)} title="Elimina">🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modale form */}
      {form && (
        <div className="modal-overlay" onClick={() => setForm(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()}>
            <h2 className="card-title">{isNuovo ? "Nuovo utente" : "Modifica utente"}</h2>

            {errore && <div className="errore-box" style={{ marginBottom: 16 }}>⚠️ {errore}</div>}

            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Nome *</label>
                <input className="form-input" value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} placeholder="Mario Rossi" />
              </div>
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input className="form-input" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="mario@isp.it" />
              </div>
              <div className="form-group">
                <label className="form-label">Password {isNuovo ? "*" : "(lascia vuoto per non cambiare)"}</label>
                <input className="form-input" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Min. 8 caratteri" />
              </div>
              <div className="form-group">
                <label className="form-label">Ruolo *</label>
                <select className="form-input" value={form.ruolo} onChange={e => setForm({...form, ruolo: e.target.value})}>
                  {RUOLI.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
              {form.ruolo === "venditore" && (
                <div className="form-group span-2">
                  <label className="form-label">Responsabile assegnato</label>
                  <select className="form-input" value={form.responsabile_id} onChange={e => setForm({...form, responsabile_id: e.target.value})}>
                    <option value="">— Nessuno —</option>
                    {responsabili.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
                  </select>
                </div>
              )}
              {!isNuovo && (
                <div className="form-group">
                  <label className="form-label">Stato account</label>
                  <select className="form-input" value={form.attivo ? "1" : "0"} onChange={e => setForm({...form, attivo: e.target.value === "1"})}>
                    <option value="1">Attivo</option>
                    <option value="0">Disabilitato</option>
                  </select>
                </div>
              )}
            </div>

            <div className="step-actions">
              <button className="btn btn-ghost" onClick={() => setForm(null)}>Annulla</button>
              <button className="btn btn-primary" onClick={salva} disabled={saving}>
                {saving ? "Salvataggio..." : "Salva"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
